import React, { PropsWithChildren, useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";

const DRAWER_WIDTH = 280;
const DRAWER_WIDTH_COLLAPSED = 80;

const BaseLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{
          flexGrow: 1,
          width: sidebarOpen
            ? `calc(100% - ${DRAWER_WIDTH}px)`
            : `calc(100% - ${DRAWER_WIDTH_COLLAPSED}px)`,
          transition: (theme) =>
            theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          mt: "88px", // AppBar height
          overflow: "auto",
          position: "relative",
          minHeight: "calc(100vh - 88px)",
          zIndex: 1,
          "&:focus": { outline: "none" },
          "&:focus-visible": { outline: "none" },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

const Layout = (page: React.JSX.Element) => (
  <BaseLayout {...page.props}>{page}</BaseLayout>
);

export default Layout;
